// src/components/PaneRight.jsx
// =====================  WHAT CHANGED  =====================
// 1. import ClimateAnalysisPanel
// 2. massingBuilt no longer force-jumps to Cost if the user is on Climate
//    (so tuning setback while watching Sun Path doesn't bounce them away)
// 3. Climate tab renders <ClimateAnalysisPanel/> instead of the coming-soon list
// ==========================================================
import React, { useState, useEffect } from 'react';
import ImageAnalysisPanel from './ImageAnalysisPanel';
import ChatPanel from './ChatPanel';
import CostAnalysisPanel from './CostAnalysisPanel';
import ClimateAnalysisPanel from './ClimateAnalysisPanel';
import DesignReferencesCard from "./DesignReferencesCard";
import AccountPanel from './AccountPanel';
import NetworkPanel from './NetworkPanel';
import MessagePanel from './MessagePanel';
import { API_BASE } from '../utils/apiBase';

// same backend origin the rest of the app uses. TODO(centralise): utils/apiBase.js
function PaneRight({ mode, selectedProject, massingResult, messageWith }) {
  const [tab, setTab] = useState('design');

  // when a massing is built, jump to Cost — UNLESS the user is on Climate
  useEffect(() => {
    const onMassing = () => setTab((t) => (t === 'climate' || t === 'design' ? t : 'cost'));
    window.addEventListener('massingBuilt', onMassing);
    return () => window.removeEventListener('massingBuilt', onMassing);
  }, []);

  // close the Design Analysis drawer when leaving the Design tab
  useEffect(() => {
    if (tab !== 'design') {
      window.dispatchEvent(new CustomEvent('closeAnalysisRequested'));
    }
  }, [tab]);

  // PaneMain owns the drawer; it echoes which panel is open so this button can
  // show its real state (it can also be closed from the drawer itself).
  const [analysisOpen, setAnalysisOpen] = useState(false);
  useEffect(() => {
    const onPanel = (e) => setAnalysisOpen(e.detail?.panel === 'analysis');
    window.addEventListener('bottomPanelChanged', onPanel);
    return () => window.removeEventListener('bottomPanelChanged', onPanel);
  }, []);

  if (!mode) return null;

  if (mode === 'login') {
    return (
      <aside className="pane-right">
        <div className="pane-right-header"><h3>Account</h3></div>
        <AccountPanel apiBase={API_BASE} />
      </aside>
    );
  }

  if (mode === 'message') {
    return (
      <aside className="pane-right">
        <div className="pane-right-header"><h3>Messages</h3></div>
        <MessagePanel apiBase={API_BASE} openWith={messageWith} />
      </aside>
    );
  }

  if (mode === 'network') {
    return (
      <aside className="pane-right">
        <div className="pane-right-header"><h3>Network</h3></div>
        <NetworkPanel apiBase={API_BASE} />
      </aside>
    );
  }

  if (mode === 'chat') {
    return (
      <aside className="pane-right">
        <div className="pane-right-header"><h3>Chat</h3></div>
        <ChatPanel />
      </aside>
    );
  }

  return (
    <aside className="pane-right">
      <div className="pane-right-header"><h3>Design Reference</h3></div>

      <div className="pane-right-tabs">
        <button className={`pane-tab ${tab === 'design' ? 'pane-tab--active' : ''}`} onClick={() => setTab('design')}>Design</button>
        <button className={`pane-tab ${tab === 'cost' ? 'pane-tab--active' : ''}`} onClick={() => setTab('cost')}>Cost Analysis</button>
        <button className={`pane-tab ${tab === 'climate' ? 'pane-tab--active' : ''}`} onClick={() => setTab('climate')}>Climate Analysis</button>
      </div>

        {/* The pane itself no longer scrolls, so the title and the tab row stay
            put; only what belongs to the selected tab moves. Everything below is
            wrapped rather than each tab being made to scroll on its own — three
            scrollers would each need the same rule and would drift apart. */}
        <div className="pane-right-scroll">

        {tab === 'design' && (
          <>
            <button
              type="button"
              className={`btn ${analysisOpen ? "is-on" : "active"}`}
              aria-pressed={analysisOpen}
              title={analysisOpen ? 'Close Design Analysis' : 'Open Design Analysis'}
              /* Was styled inline with its own flat greens and blues, so it was
                 the one control that did not follow the button tokens — a flat
                 green next to gradient ones. The classes carry both states. */
              style={{ width: '100%', marginBottom: 10 }}
              onClick={() => window.dispatchEvent(new CustomEvent('toggleAnalysisRequested'))}
            >
              Design Analysis{analysisOpen ? ' ▾' : ''}
            </button>
            <DesignReferencesCard
              project={selectedProject}
              initialFloors={massingResult?.floors}
            />
          </>
        )}

        {tab === 'cost' && (
          <CostAnalysisPanel massing={massingResult} project={selectedProject} />
        )}

        {tab === 'climate' && (
          <div className="pane-right-section">
            <ClimateAnalysisPanel project={selectedProject} />
          </div>
        )}
        </div>
    </aside>
  );
}

export default PaneRight;
